import { Icon } from "@iconify/react/dist/iconify.js";
import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";

const FooterRap = styled.div`
  .upper-1 h6 {
    color: #363d4f;
    font-weight: 400;
    font-size: 16px;
  }
  .upper-1 h3 {
    color: #060b13;
    font-size: 40px;
    font-weight: 600;
  }
  .upper-1 p {
    color: #ed1c24;
    font-size: 14px;
    font-weight: 400;
  }
  .sub-upper-2 input {
    border: 1px solid #bac0d4b2;
    background: #ffffff;
    border-radius: 99px;
    width: 280px;
    height: 55px;
    padding-left: 10px;
  }
  .start-trial-btn {
    border-left: 2px;
    border-top: 2px;
    border-right: 5px;
    border-bottom: 5px;
    border-style: solid;
    border-radius: 100px;
    width: 190px;
    border-color: #060b13;
    height: 55px;
    display: flex;
    justify-content: center;
    align-items: center;
    text-decoration: none;
    background: #ed1c24;
    color: #ffffff;
    font-weight: 600;
    font-size: 16px;
  }
  .sub-upper-2 {
    display: flex;
    gap: 15px;
  }
  .mark-free {
    background: #ed1c24;
    width: 22px;
    height: 22px;
    border-radius: 999px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .sub-free p {
    color: #363D4F;
    font-size: 14px;
    font-weight: 400;

  }
  .sub-free  {
    display: flex;
    align-items: center;
    gap: 10px;
  }
  .sub-upper-3 {
    display: flex;
    align-items: center;
    gap: 15px;
  }
  .upper-1 {
    display: flex;
    gap: 10px;
    flex-direction: column;
  }
  .upper-2 {
    display: flex;
    align-items: center;
    gap: 15px;
    flex-direction: column;
  }
  .upper-footer {
    background: #F7F8FA;
    height: 300px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .icon-circle {
    border: 1px solid #FFFFFF;
    width: 52px;
    height: 52px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .down-sub-1 p {
    color: #ffffff;
    font-size: 16px;
    font-weight: 300;
  }
  .down-sub-1 {
    display: flex;
    align-items: center;
    gap: 15px;
  }
  .down-1 {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .down-footer {
    background: #060B13;
    padding-top: 80px;
    padding-bottom: 80px;
  }
  .links-div h5 {
    color: #8189A0;
    font-size: 14px;
    font-weight: 600;
  }
  .footer-link {
    text-decoration: none;
    color: #5E667C;
    font-size: 14px;
    font-weight: 400;
    display: flex;
    align-items: center;
    gap: 5px;
  }
  .links-div {
    display: flex;
    flex-direction: column;
    gap: 15px;
  }
  .down-2 {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    border-top: 1px solid #111C2E;
    border-bottom: 1px solid #111C2E;
    padding-top: 50px;
    padding-bottom: 50px;
    margin: 50px 0px;
  }
  .down-3 {
    color: #5E667C;
    font-size: 14px;
    font-weight: 400;
  }
  @media (max-width: 992px) {
    .upper-footer {
        flex-wrap: wrap;
        gap: 20px;
    }
  }
  @media (max-width: 600px) {
    .sub-upper-2, .sub-upper-3, .down-1 {
        flex-wrap: wrap;
        gap: 20px;
    }
    .upper-footer {
        height: auto !important;
        padding-top: 30px;
        padding-bottom: 30px;
    }
    .down-2 {
        grid-template-columns: repeat(3, 1fr);
    }
  }
  @media (max-width: 450px) {
    .down-sub-1 {
        flex-wrap: wrap;
    }
    .down-2 {
        grid-template-columns: repeat(2, 1fr);
    }
  }
`;

const Footer = () => {
  return (
    <FooterRap>
      <div className="upper-footer containery">
        <div className="upper-1">
          <p>Start building today!</p>
          <h3>Start your 7-day free trial</h3>
          <h6>Experience Pluglr and unlock your true potential</h6>
        </div>
        <div className="upper-2">
          <div className="sub-upper-2">
            <input type="email" placeholder="Enter your email" />
            <Link className="start-trial-btn">Start free trial</Link>
          </div>
          <div className="sub-upper-3">
            <div className="sub-free">
              <div className="mark-free">
                <Icon
                  width="14px"
                  height="14px"
                  icon="fluent-mdl2:check-mark"
                  style={{ color: "#FFFFFF" }}
                />
              </div>
              <p>Free 7-day trial</p>
            </div>
            <div className="sub-free">
              <div className="mark-free">
                <Icon
                  width="14px"
                  height="14px"
                  icon="fluent-mdl2:check-mark"
                  style={{ color: "#FFFFFF" }}
                />
              </div>
              <p>No credit card required</p>
            </div>
          </div>
        </div>
      </div>
      <div className="down-footer containery">
        <div className="down-1">
            <img src="/images/footer-logo.png" alt="" />
            <div className="down-sub-1">
                <p>Pluglr is available on</p>
                <div className="icon-circle">
                    <img src="/images/window.png" alt="" />
                </div>
                <div className="icon-circle">
                    <img src="/images/store.png" alt="" />
                </div>
                <div className="icon-circle">
                    <img src="/images/apple.png" alt="" />
                </div>
            </div>
        </div>
        <div className="down-2">
            <div className="links-div">
                <h5>Quick Links</h5>
                <Link className="footer-link">Company
                <Icon
                  width="8px"
                  height="8px"
                  icon="akar-icons:arrow-up-right"
                  style={{ color: "#5E667C" }}
                />
                </Link>
                <Link className="footer-link">Features
                <Icon
                  width="8px"
                  height="8px"
                  icon="akar-icons:arrow-up-right"
                  style={{ color: "#5E667C" }}
                />
                </Link>
                <Link className="footer-link">Princing
                <Icon
                  width="8px"
                  height="8px"
                  icon="akar-icons:arrow-up-right"
                  style={{ color: "#5E667C" }}
                />
                </Link>
                <Link className="footer-link">Contact
                <Icon
                  width="8px"
                  height="8px"
                  icon="akar-icons:arrow-up-right"
                  style={{ color: "#5E667C" }}
                />
                </Link>
            </div>
            <div className="links-div">
                <h5>Resources</h5>
                <Link className="footer-link">Blog</Link>
                <Link className="footer-link">Download</Link>
                <Link className="footer-link">Careers</Link>
                <Link className="footer-link">Support</Link>
            </div>
            <div className="links-div">
                <h5></h5>
                <Link className="footer-link">Terms of Service</Link>
                <Link className="footer-link">Privacy Policy</Link>
            </div>
            <div className="links-div">
                <h5></h5>
                <Link className="footer-link">YouTube</Link>
                <Link className="footer-link">Instagram</Link>
                <Link className="footer-link">Twitter</Link>
                <Link className="footer-link">Facebook</Link>
                <Link className="footer-link">Tiktok</Link>
            </div>
        </div>
        <p className="down-3">© 2024 Pluglr, All rights reserved</p>
      </div>
    </FooterRap>
  );
};

export default Footer;
